import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import configureStore from '../../redux/store'
import userManager from '../../utils/userManager'
import { OidcProvider } from 'redux-oidc'
import Routes from '../Routes'
import ReactNotification from 'react-notifications-component'
import Axios from 'axios'
import { showErrorNotification } from '../../services/notificationsService'
import './App.css'
import 'react-notifications-component/dist/theme.css'

const store = configureStore()

const App: React.FC = () => {
  useEffect(() => {
    Axios.interceptors.response.use(
      response => response,
      error => {
        const notification = {
          title: 'Error!',
          message: error.response.data.errorMessage || 'Something went wrong',
        }
        showErrorNotification(notification)
        return Promise.reject(error)
      }
    )
  }, [])

  return (
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <Routes />
      </OidcProvider>
      <ReactNotification />
    </Provider>
  )
}

export default App
